var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.productHasMinOrderQuantity)?_c('div',{staticClass:"c-gray-700 text-sm mt-md"},[_vm._v("\n  "+_vm._s(_vm._f("t")('This product must be ordered in quantity of'))+" "+_vm._s(_vm.minOrderQuantity)+".\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }